import { useEffect, useRef } from 'react';
/**
 * get that component mounted state `ref`
 *
 * @example
 *
 * ```ts
    const isMountedRef = useMountState();

    if (isMountedRef.current) {
      console.log('component mounted');
    }
 *
 * ```
 */
export var useMountState = function () {
    var isMountedRef = useRef(false);
    useEffect(function () {
        isMountedRef.current = true;
        return function () {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
};
